import { cn } from "@/lib/utils";

/**
 * Attestra brand marks (served from /public).
 *
 *  <Logo />                         – full horizontal lockup (mark + wordmark)
 *  <Logo mark />                    – square mark only
 *  <Logo onDark />                  – inverted variant for dark surfaces
 *  <Logo mark onDark />             – inverted mark only
 *  <Logo className="h-10" />        – control size via tailwind height class
 */
export default function Logo({
  mark = false,
  onDark = false,
  className,
}) {
  const file = mark
    ? onDark ? "/attestra-mark-on-dark.png" : "/attestra-mark.png"
    : onDark ? "/attestra-logo-on-dark.png" : "/attestra-logo.png";

  return (
    <img
      src={file}
      alt="Attestra"
      draggable={false}
      className={cn(
        "select-none",
        mark ? "h-9 w-auto" : "h-7 w-auto",
        className,
      )}
    />
  );
}
